module.exports = __webpack_public_path__ + "img/sbg_logo.c92367ae.png";